import React from "react";
import "./NotFound404.css";

const NotFound404 = () => (
  <section className="page_404">
    <div className="container">
      <h1 className="notfound-title">404</h1>
      <div className="four_zero_four_bg"></div>
      <div className="contant_box_404">
        <h3 className="h2">Look like you're lost</h3>
        <p>the page you are looking for not available!</p>
        <a href="/" className="link_404">Go to Home</a>
      </div>
    </div>
  </section>
);

export default NotFound404; 